import { render, staticRenderFns } from "./navigate-left.vue?vue&type=template&id=4b0b01ce&scoped=true&"
import script from "./navigate-left.vue?vue&type=script&lang=js&"
export * from "./navigate-left.vue?vue&type=script&lang=js&"
import style0 from "./navigate-left.vue?vue&type=style&index=0&id=4b0b01ce&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b01ce",
  null
  
)

export default component.exports